import type { SVGProps } from "react";

/** Octagon with X — matches curve-management duplicate-name / Figma `errorFilled`. */
export function ErrorFilledIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Decorative icon; parent supplies accessible context
    <svg
      width={20}
      height={20}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
      {...props}
    >
      <path
        d="M6.13619 1.88941C6.5465 1.47909 7.10385 1.25 7.68513 1.25H12.3217C12.903 1.25 13.4603 1.47909 13.8707 1.88941L18.1106 6.13619C18.5209 6.5465 18.75 7.10385 18.75 7.68513V12.3217C18.75 12.903 18.5209 13.4603 18.1106 13.8707L13.8672 18.1106C13.4569 18.5209 12.8996 18.75 12.3183 18.75H7.68171C7.10043 18.75 6.54308 18.5209 6.13277 18.1106L1.88941 13.8638C1.47909 13.4535 1.25 12.8996 1.25 12.3183V7.68171C1.25 7.10043 1.47909 6.54308 1.88941 6.13277L6.13619 1.88941ZM6.96024 6.95682C6.63882 7.27823 6.63882 7.79797 6.96024 8.11596L8.84086 9.99658L6.96024 11.8772C6.63882 12.1986 6.63882 12.7183 6.96024 13.0363C7.28165 13.3543 7.80139 13.3578 8.11938 13.0363L10 11.1557L11.8806 13.0363C12.202 13.3578 12.7218 13.3578 13.0398 13.0363C13.3578 12.7149 13.3612 12.1952 13.0398 11.8772L11.1591 9.99658L13.0398 8.11596C13.3612 7.79455 13.3612 7.27481 13.0398 6.95682C12.7183 6.63882 12.1986 6.6354 11.8806 6.95682L10 8.83744L8.11938 6.95682C7.79797 6.6354 7.27823 6.6354 6.96024 6.95682Z"
        fill="currentColor"
      />
    </svg>
  );
}
